import "./mqtt-patch"; // First import
import "core-js/stable"; // Polyfills ES6+ (Array.includes, Promises, etc.)
import "regenerator-runtime/runtime"; // For async/await
import "whatwg-fetch"; // Polyfills fetch() API
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
import "./index.css";
import "./i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
